export const EncryptedIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <rect width="28" height="28" rx="14" fill="#F4F4F4" />
      <mask
        id="mask0_4266_4530"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="4"
        y="4"
        width="20"
        height="20"
      >
        <rect x="4" y="4" width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4266_4530)">
        <path
          d="M12.7917 16.5H15.2083L14.75 13.8125C14.9825 13.6883 15.1656 13.5083 15.2994 13.2723C15.4331 13.0363 15.5 12.7755 15.5 12.4898C15.5 12.0799 15.3527 11.7292 15.0581 11.4375C14.7635 11.1458 14.4094 11 13.9956 11C13.5819 11 13.2292 11.1469 12.9375 11.4406C12.6458 11.7344 12.5 12.0875 12.5 12.5C12.5 12.7835 12.5669 13.0423 12.7006 13.2765C12.8344 13.5106 13.0175 13.6893 13.25 13.8125L12.7917 16.5ZM14 22C12.125 21.5417 10.5729 20.4803 9.34375 18.8158C8.11458 17.1513 7.5 15.3029 7.5 13.2708V8.5L14 6L20.5 8.5V13.2708C20.5 15.3029 19.8854 17.1513 18.6562 18.8158C17.4271 20.4803 15.875 21.5417 14 22ZM14 20.4375C15.4444 19.9896 16.6389 19.0938 17.5833 17.75C18.5278 16.4062 19 14.9132 19 13.2708V9.52083L14 7.60417L9 9.52083V13.2708C9 14.9132 9.47222 16.4062 10.4167 17.75C11.3611 19.0938 12.5556 19.9896 14 20.4375Z"
          fill="#1C1B1F"
        />
      </g>
    </svg>
  );
};
